import { useQuery } from "@tanstack/react-query";
import {
	type GetNewRollsParams,
	getNewRollsData,
} from "../repositories/NewRollsRepository";

type UseNewRollsParams = Omit<GetNewRollsParams, "signal">;

export const useNewRolls = ({ start, end }: UseNewRollsParams) => {
	return useQuery({
		queryKey: ["newRolls", start, end],
		queryFn: ({ signal }) => getNewRollsData({ start, end, signal }),
		enabled: !!start && !!end,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};
